import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import coinsHeader from '../../../assets/coins-header.png';
import Button from '../../../components/buttons/Button';
import { DialogContent } from '../../../components/Dialog/DialogContent';
import { DialogHeader } from '../../../components/Dialog/DialogHeader';
import type { WizardChildProps } from '../../../components/Wizard/types';
import { CONTACT_SUPPORT_URL } from '../../../config/constants';
import type { RootStore } from '../../../stores/RootStore';
import { useStores } from '../../../stores/useStores';

import styles from './PlayerKycInvitation.module.scss';

export function playerKycInvitationFactory(onClose: (stores: RootStore) => void) {
  return observer(function PlayerKycInvitation(props: WizardChildProps) {
    const stores = useStores();
    const { t } = useTranslation();

    return (
      <>
        <DialogHeader
          title={
            <>
              <img alt="coins header" className={styles.coinsHeader} src={coinsHeader} />
              {t('kyc.userVerification')}
            </>
          }
          onClose={() => onClose(stores)}
        />
        <DialogContent className={styles.content}>
          <p className={styles.text}>
            {t('kyc.responsibleGamingMessage')}
            <span>{t('kyc.pleaseVerification')}</span>
          </p>
          <Button btnType="main" className={styles.okButton} onClick={() => props.nextStep()}>
            {t('kyc.letsDoIt')}
          </Button>
          <a
            className={classNames('button-action support-button animation-popup', styles.contactSupportButton)}
            href={CONTACT_SUPPORT_URL}
            rel="noreferrer"
            target="_blank"
          >
            {t('common.contactSupport')}
          </a>
        </DialogContent>
      </>
    );
  });
}
